<template>
    <client-page class="app--main">
        <!-- S: sub-visual -->
        <section class="sub-visual">
            <v-container>
                <div class="tit-wrap mb-24 mb-md-50 mb-lg-0">
                    <v-img class="tit-wrap__img" src="/images/common/tit-img.png"></v-img>
                    <h2 class="tit tit--xl">
                        Business
                    </h2>
                </div>
            </v-container>
            <v-img class="sub-visual__img" src="/images/sub/business/sub-visual-business.jpg"></v-img>
            <sub-tab page="비즈니스" :tabActive="2"></sub-tab>
        </section>
        <!-- E: sub-visual -->

        <!-- S: vnm -->
        <section class="sub-section sub-section--vnm">
            <v-container>
                <v-row no-gutters class="text-center text-md-left">
                    <v-col cols="12">
                        <div class="pb-30 pb-md-44 pb-lg-60">
                            <v-row>
                                <v-col cols="12" md="4" lg="3">
                                    <v-card flat width="300" height="78" color="#32ABCA" class="d-flex justify-center align-center rounded-pill ma-auto ma-md-0">
                                        <span class="white--text line-height-135 font-weight-bold font-size-32">Vision</span>
                                    </v-card>
                                </v-col>
                                <v-col cols="12" md="8" lg="9" class="d-flex align-center">
                                    <div class="ma-auto ma-md-0">
                                        <div class="tit-wrap tit-wrap--xs">
                                            <h3 class="tit tit--sm">
                                                모두를 위한 음식, 식자재 토탈 솔루션
                                            </h3>
                                        </div>
                                        <p class="page-text font-weight-medium grey--text">
                                            제 2의 도약을 위해 더욱 신뢰받고 책임있는 기업으로 나아가고자 합니다.
                                        </p>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>

                    <v-col cols="12">
                        <div class="pb-30 pb-md-44 pb-lg-60">
                            <v-row>
                                <v-col cols="12" md="4" lg="3">
                                    <v-card flat width="300" height="78" color="#277AB6" class="d-flex justify-center align-center rounded-pill ma-auto ma-md-0">
                                        <span class="white--text line-height-135 font-weight-bold font-size-32">Mission</span>
                                    </v-card>
                                </v-col>
                                <v-col cols="12" md="8" lg="9" class="d-flex align-center">
                                    <div class="ma-auto ma-md-0">
                                        <div class="tit-wrap tit-wrap--xs">
                                            <h3 class="tit tit--sm">
                                                함께 할수있는 식문화를 널리 알리는 것
                                            </h3>
                                        </div>
                                        <p class="page-text font-weight-medium grey--text">
                                            좋은 사람과 좋은 분위기 속 맛있는 음식을 모두와 함께 즐기는 장소를 위해 더욱 유통에 부지런히 힘쓰는 것입니다. 
                                        </p>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>

                    <v-col cols="12">
                        <div class="pb-30 pb-md-44 pb-lg-60">
                            <v-row class="align-center">
                                <v-col cols="12" md="4" lg="3">
                                    <v-card flat width="300" height="78" color="#BBCF62" class="d-flex justify-center align-center rounded-pill ma-auto ma-md-0">
                                        <span class="white--text line-height-135 font-weight-bold font-size-32">Goal setting</span>
                                    </v-card>
                                </v-col>
                                <v-col cols="12" md="8" lg="9" class="d-flex align-center">
                                    <div class="page-text font-weight-medium grey--text ma-auto ma-md-0">
                                        <p>
                                            2030년 까지 모두 에프엔티의 독자적인 프랜차이즈 브랜드 생성
                                        </p>
                                        <p class="mt-6 mt-md-8 mt-lg-12">
                                            연매출 200억 이상 달성 목표 
                                        </p>
                                        <p class="mt-6 mt-md-8 mt-lg-12">
                                            B2B 를 넘어 B2C 까지 종합 식자재 구매 쇼핑몰 구축 예정 
                                        </p>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                </v-row>
                <!-- S: principles -->
                <v-card flat class="mt-30 mt-md-44 mt-lg-60 py-50 py-md-74 py-lg-100 border">
                    <div class="tit-wrap tit-wrap-xs tit-wrap--center">
                        <h4 class="tit font-pretendard line-height-135 mb-6 mb-md-8 mb-lg-12" data-aos="fade-up">(주) 모두 에프엔티의</h4>
                        <h3 class="tit tit--lg" data-aos="fade-up" data-aos-delay="100">PRINCIPLES</h3>
                    </div>
                    <v-container>
                        <v-img class="ma-auto" max-width="942" data-aos="fade-up" data-aos-delay="200" src="/images/sub/business/vnm/principles.png"></v-img>
                    </v-container>
                </v-card>
                <!-- E: principles -->
            </v-container>
        </section>
        <!-- E: vnm -->

        <!-- S: competencies -->
        <section class="sub-section sub-section--competencies">
            <v-container>
                <div class="tit-wrap tit-wrap--center">
                    <h3 class="tit tit--lg">핵심역량</h3>
                </div>
                <v-row class="justfy-space-between">
                    <v-col cols="12" md="6" lg="" align="center">
                        <div class="d-flex justify-lg-start" data-aos="fade-up">
                            <div class="core w-100">
                                <v-card flat class="white--text rounded-circle d-flex justify-center align-center w-100" img="/images/sub/business/vnm/life-style.jpg">
                                    <div>
                                        <div class="tit-wrap tit-wrap--center tit-wrap--xs">
                                            <p class="page-text page-text--xs">
                                                LIfe Style
                                            </p>
                                        </div>
                                        <h3 class="tit font-pretendard">
                                            #라이프 스타일
                                        </h3>
                                    </div>
                                </v-card>
                                <p class="page-text mt-16 mt-md-24 mt-lg-32">
                                    모두의 고객이 건강한 라이프스타일을 누릴 수 <br />
                                    있도록 최상의 퀄리티의 서비스를 제공합니다.
                                </p>
                            </div>
                        </div>
                    </v-col>

                    <v-col cols="12" md="6" lg="" align="center">
                        <div class="core w-100" data-aos="fade-up" data-aos-delay="100">
                            <v-card flat class="white--text rounded-circle d-flex justify-center align-center w-100" img="/images/sub/business/vnm/trust.jpg">
                                <div>
                                    <div class="tit-wrap tit-wrap--center tit-wrap--xs">
                                        <p class="page-text page-text--xs">
                                            Trust
                                        </p>
                                    </div>
                                    <h3 class="tit font-pretendard">
                                        #신뢰
                                    </h3>
                                </div>
                            </v-card>
                            <p class="page-text mt-16 mt-md-24 mt-lg-32">
                                모두에프엔티는 합리적 가격과 정직한 상품으로<br />
                                고객과 함께 지속 가능한 미래를 그립니다.
                            </p>
                        </div>
                    </v-col>

                    <v-col cols="12" md="6" lg="" class="ma-auto" align="center">
                        <div class="d-flex justify-lg-end" data-aos="fade-up" data-aos-delay="200">
                            <div class="core w-100">
                                <v-card flat class="white--text rounded-circle d-flex justify-center align-center w-100" img="/images/sub/business/vnm/satisfaction.jpg">
                                    <div>
                                        <div class="tit-wrap tit-wrap--center tit-wrap--xs">
                                            <p class="page-text page-text--xs">
                                                Satisfaction
                                            </p>
                                        </div>
                                        <h3 class="tit font-pretendard">
                                            #고객만족
                                        </h3>
                                    </div>
                                </v-card>
                                <p class="page-text mt-16 mt-md-24 mt-lg-32">
                                    고객의 피드백을 발빠르게 반영하여<br />
                                    만족도를 제공합니다.
                                </p>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <!-- E: competencies -->
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubTab from "@/components/client/sub/sub-tab.vue";
// import BoardList from "@/components/client/board/board-list.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import LocaleSelect from "@/components/client/inc/locale-select.vue";
import { BOARD_YOUTUBE_CATEGORIES, BOARD_REPORT_CATEGORIES, BOARD_FORMS_CATEGORIES } from "@/assets/variables";
import Swiper from "swiper/bundle";
import IconArrowRounded from "@/components/client/icons/icon-arrow-rounded.vue";

const categoriesYoutube = Object.values(BOARD_YOUTUBE_CATEGORIES);
const categoriesReport = Object.values(BOARD_REPORT_CATEGORIES);
const categoriesForms = Object.values(BOARD_FORMS_CATEGORIES);

export default {
    components: {
        ClientPage,
        SubTab,
        // BoardList,
        PopupLayer,
        LocaleSelect,
        IconArrowRounded,
    },
    props: {
        isMain: { type: Boolean, default: true },
    },
    data: () => ({
        categoriesYoutube,
        categoriesReport,
        categoriesForms,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {
                this.Swiper = new Swiper(".products-slide .swiper-container", {
                    slidesPerView: 1,
                    spaceBetween: 120,
                    speed: 1000,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    breakpoints: {
                        // pc
                        768: {
                            slidesPerView: 2,
                        },
                    },
                });
            });
        },
    },
};
</script>
